import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	scanJobs: [],
	total: 0,
	page: 1,
	limit: 10,
	loading: false
};

export default function scanHistoryPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_SCAN_HISTORY_REQUEST:
		case ActionTypes.GET_SCAN_HISTORY_ERROR:
		case ActionTypes.GET_SCAN_HISTORY_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_SCAN_HISTORY_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
